// extracted by mini-css-extract-plugin
module.exports = {"trigger":"region-select_trigger__QCK7i","value":"region-select_value__2lgbd"};